import React, { useEffect, useState } from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
export function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const anchor = document.getElementById('primary-cta');
    if (!anchor) return;
    const observer = new IntersectionObserver(([entry]) => {
      const passed = entry.boundingClientRect.top < 0;
      setVisible(!entry.isIntersecting && passed);
    }, {
      threshold: 0
    });
    observer.observe(anchor);
    return () => observer.disconnect();
  }, []);
  return <div className={['fixed inset-x-0 bottom-0 z-40 px-3 pb-3 transition-[opacity,transform] duration-200 ease-out', visible ? 'translate-y-0 opacity-100' : 'pointer-events-none translate-y-6 opacity-0'].join(' ')} data-id="element-34" data-mp="2ftwdpdjzxjp0">
      <div className="mx-auto max-w-lg" data-id="element-35" data-mp="38cs5g34iv7su">
        <a href={CHECKOUT_URL} className="animate-shake flex w-full items-center justify-center gap-2 rounded-2xl bg-gogreen-500 px-4 py-4 text-center text-[14px] font-extrabold uppercase leading-tight tracking-tight text-white shadow-[0_8px_24px_rgba(5,14,28,0.35)] transition-colors duration-150 ease-out hover:bg-gogreen-600 focus:outline-none focus-visible:ring-4 focus-visible:ring-white/50 sm:text-base" data-id="element-36" data-mp="33jyxz7ho5ld2">
          <span data-id="element-37" data-mp="2u9ejecq5wkj1">Get Mechanics Decision Map™ — $27</span>
          <ArrowRightIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-38" data-mp="2fdp1apo3krjl" />
        </a>
      </div>
    </div>;
}